export default __webpack_public_path__ + "static/media/logo.c475b054.svg";